import { Outlet } from 'react-router-dom';
import { usePermissions } from '@/hooks/usePermissions';
import AccessDenied from './AccessDenied';

/**
 * Route wrapper that requires admin access.
 * Shows a loading spinner while checking permissions,
 * an access denied page if not admin, or the child route if admin.
 *
 * Usage in App.tsx:
 * ```tsx
 * <Route element={<ProtectedAdminRoute />}>
 *   <Route path="/organizations" element={<OrganizationsPage />} />
 *   <Route path="/billing" element={<BillingSettingsPage />} />
 * </Route>
 * ```
 */
export default function ProtectedAdminRoute() {
  const { isAdmin, isLoading } = usePermissions();

  // Show loading spinner while checking permissions
  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-[60vh]">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-600 dark:border-primary-400" />
      </div>
    );
  }

  // Show access denied if not admin
  if (!isAdmin) {
    return <AccessDenied />;
  }

  // Render the child route
  return <Outlet />;
}
